import React from 'react';
import { X, Clock, Check, AlertTriangle } from 'lucide-react';
import { DocumentStatus } from '../../types/documents';

interface DocumentStatusBadgeProps {
  status: DocumentStatus;
  className?: string;
}

export const DocumentStatusBadge: React.FC<DocumentStatusBadgeProps> = ({
  status,
  className = ''
}) => {
  const getStatusConfig = () => {
    switch (status) {
      case DocumentStatus.MISSING:
        return {
          icon: X,
          label: 'Manquant',
          className: 'bg-red-100 text-red-800 border-red-200'
        };
      case DocumentStatus.UPLOADED:
        return {
          icon: Clock,
          label: 'Déposé',
          className: 'bg-orange-100 text-orange-800 border-orange-200'
        };
      case DocumentStatus.VERIFIED:
        return {
          icon: Check,
          label: 'Vérifié',
          className: 'bg-green-100 text-green-800 border-green-200'
        };
      case DocumentStatus.REJECTED:
        return {
          icon: AlertTriangle,
          label: 'Rejeté',
          className: 'bg-red-100 text-red-800 border-red-200'
        };
      default:
        return {
          icon: X,
          label: 'Inconnu',
          className: 'bg-gray-100 text-gray-800 border-gray-200'
        };
    }
  };

  const { icon: Icon, label, className: statusClassName } = getStatusConfig();

  return (
    <span className={`inline-flex items-center space-x-1 px-2 py-1 rounded-full text-xs font-medium border ${statusClassName} ${className}`}>
      <Icon className="w-3 h-3" />
      <span>{label}</span>
    </span>
  );
};